// extracted by mini-css-extract-plugin
module.exports = {"customInfinitscroll":"MyFileContainer_customInfinitscroll__3Dbig","textEmpty":"MyFileContainer_textEmpty__2YkRI"};